(() => {
  function attachExamples(root = document) {
    root.querySelectorAll('[data-scenarios]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.querySelectorAll('[data-scene]').forEach(button => button.addEventListener('click', () => {
        section.querySelectorAll('[data-scene]').forEach(item => { const active = item === button; item.setAttribute('aria-pressed', String(active)); item.classList.toggle('is-active', active); });
        section.querySelector('[data-example-text]').textContent = button.dataset.example;
        section.querySelector('[data-example-label]').textContent = button.dataset.label;
      }));
    });
  }
  attachExamples();
  document.addEventListener('shopify:section:load', event => attachExamples(event.target));
  document.querySelectorAll('.mobile-nav').forEach(menu => {
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  });
})();
